import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles((theme) => ({
  bgBlue: {
    backgroundColor: '#F4F8FFFC',
  },
  bgDeepBlue: {
    backgroundColor: '#E3E8F4',
  },
  customQuotePatientButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 16px',
    gap: '8px',
    background: '#F4F7FF',
    color: '#32324D',
    border: '1px dashed rgba(50, 50, 77, 0.99)',
    borderRadius: '4px',
    flex: 1,
  },
  customIcon: {
    color: 'black',
    height: '2rem',
    width: '2rem',
    lineHeight: '2rem'
  },
  searchField: {
    marginTop: '2rem',
    marginBottom: '2rem',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    backgroundColor: '#F6F6F9',
  },
  tabIndicator: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#4f6db2',
  },
  patientActivityButton: {
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    border: '1px solid var(--light-mode-neutral-200, #DCDCE4)',
    backgroundColor: '#F6F6F9',
    color: '#32324D',
    fontWeight: 600,
    maxWidth: '200px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'initial',
    },
  },
  fullWidthTabs: {
    width: '100%',
    justifyContent: 'space-between',
  },
  activeTab: {
    fontWeight: 'bold',
    color: '#4f6db2',
  },
  inactiveTab: {
    fontWeight: 'bold',
    color: '#70708e',
  },
  tableAutoLayout: {
    tableLayout: 'auto'
  },
  tableContainer: {
    maxWidth: '1050px',
    borderRadius: '.5rem',
    background: '#FFFFFF',
    border: '1px solid #DCDCE4',
    '& .MuiTableCell-root': {
      borderBottomColor: '#DCDCE4'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#666687',
      fontWeight: '600',
      fontSize: '11px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4f6db2'
    },
    '& .MuiTableCell-body': {
      color: '#32324D',
      fontSize: '13px'
    },
  },
  selectedItemsTable: {
    minWidth: '590px',
    overflowX: 'auto',
    '& .MuiTableRow-root': {
      verticalAlign: 'top'
    },
    '& .MuiTableCell-body': {
      color: '#32324D'
    }
  },
  quotePlanTableShadowRight: {
    position: 'absolute',
    width: '10px',
    right: 0,
    top: 0,
    bottom: 0,
    '@media screen and (max-width: 1600px) and (min-width: 959px)': {
      boxShadow: 'inset -10px 0px 15px -10px rgba(214,214,214,1)'
    },
    '@media screen and (max-width: 910px)': {
      boxShadow: 'inset -10px 0px 15px -10px rgba(214,214,214,1)'
    }
  },
  quotePlanTableShadowLeft: {
    position: 'absolute',
    width: '10px',
    left: 0,
    top: 0,
    bottom: 0,
    '@media screen and (max-width: 1600px) and (min-width: 959px)': {
      boxShadow: 'inset 10px 0px 15px -10px rgba(214,214,214,1)'
    },
    '@media screen and (max-width: 910px)': {
      boxShadow: 'inset 10px 0px 15px -10px rgba(214,214,214,1)'
    }
  },
  quotePlanTable: {
    minWidth: '830px',
    overflowX: 'auto',
    '& .MuiTableRow-root': {
      verticalAlign: 'top'
    },
    '& .MuiTableCell-body': {
      color: '#32324D'
    }
  },
  paginationContainer: {
    maxWidth: '1050px',
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  autocompleteInput: {
    '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
      padding: 0,
    },
  },
  marketingSegment: {
    '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
      padding: '0 6px',
    },
  },
  customQuoteSummaryButton: {
    gap: '8px',
    borderRadius: '4px',
    flex: 1,
    fontSize: '14px'
  },
  disabledCustomQuoteSummaryButton: {
    color: '#FFF !important'
  },
  customQuoteSummaryTypography: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#32324D',
  },
  closeButton: {
    background: '#FFFFFF',
    border: '1px solid #DCDCE4',
    borderRadius: '4px',
  },
  closeIcon: {
    color: '#212134',
  },
  patientName: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#32324D',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap'
  },
  patientTitle: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#32324D',
    textTransform: 'capitalize',
  },
  patientInfo: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#32324D',
    marginLeft: '.5rem',
    width: '100%',
    wordBreak: 'break-word'
  },
  media: {
    height: '25%',
    width: '25%',
    borderRadius: '50%',
    background: '#ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    width: '40px',
    height: '40px',
    fontSize: '16px',
    fontWeight: 'bold',
    background: '#3C6AD8',
    boxShadow: '0 0 0 2px white, 0 0 0 4px #4FBCA8',
    marginRight: '1rem'
  },
  changePatient: {
    backgroundColor: '#103A99',
    color: '#fff',
    maxWidth: '200px',
    width: '100%',
    padding: '0.5rem 1rem',
    textTransform: 'capitalize',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#0b286b',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'initial',
    },
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  logoContainer: {
    display: 'flex',
  },
  gridItem: {
    height: '100%',
  },
  patientContainer: {
    '& > .MuiGrid-item': {
      [theme.breakpoints.down('md')]: {
        padding: `0 ${theme.spacing(2)}px`
      },
    },
  },
  logo: {
    height: '30px',
    width: '30px',
    borderRadius: '50%',
    background: '#e9e9e9',
    marginLeft: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #4FBCA8',
  },
  createdQuotesCard: {
    padding: '15px',
    borderRadius: '8px',
    height: 'calc(100% - 35px)',
  },
  createdQuotesTable: {
    width: '100%',
    '& .MuiTableRow-root': {
      verticalAlign: 'top'
    }
  },
  deleteIcon: {
    padding: '12.5px',
    gap: '10px',
    width: '40px',
    height: '40px',
    background: '#E1E6F2',
    border: '1.25px solid #FFFFFF',
    borderRadius: '5px',
  },
  quoteGroupDotted: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    width: 'auto',
    marginBottom: '12px',
    padding: '10px 10px 0',
    '@media screen and (max-width: 768px)': {
      margin: '15px',
      padding: '15px',
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: '-8px'
    },
    '& .MuiSelect-icon': {
      right: '0'
    },
  },
  quoteItem: {
    '@media screen and (max-width: 1279px)': {
      margin: '1rem 0',
      padding: '1rem',
      borderRadius: '1rem',
      '&:nth-child(even)': {
        backgroundColor: '#f4f7ff',
      }
    }
  },
  marketingSegmentsDotted: {
    border: '1px dashed #C0C0CF',
    borderRadius: '4px',
    width: 'auto',
    margin: '0px 0',
    padding: '10px 30px',
    '@media screen and (max-width: 768px)': {
      margin: '15px',
      padding: '15px',
    }
  },
  link: {
    color: '#103A99'
  },
  quoteSummaryCTAButton: {
    backgroundColor: '#F6F6F9',
    border: '1px solid #DCDCE4',
    borderRadius: '4px',
    color: '#32324D',
    fontWeight: 600
  },
  quoteCTAButton: {
    backgroundColor: '#F0F0FF',
    border: '1px solid #D9D8FF',
    borderRadius: '4px',
    color: '#32324D',
    fontWeight: 600
  },
  quoteSummaryTable: {
    backgroundColor: '#F4F7FF',
    borderWidth: '0',
    borderRadius: '4px',
  },
  quoteSummaryTableImage: {
    filter: 'drop-shadow(0px 1px 4px rgba(33, 33, 52, 0.1))',
    borderRadius: '4px',
    maxHeight: '60px',
    width: '100%',
    minWidth: '60px',
    objectFit: 'contain',
    padding: '5px'
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  profilePaginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  profileActionTable: {
    margin: '20px',
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto',
      margin: 0
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF',
      padding: '12px'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777'
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px'
    }
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  modalTitle: {
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: '0.15px',
    color: '#4B6FC2',
    marginBottom: '25px'
  },
  noBorder: {
    '& .MuiTableCell-root': {
      borderBottom: 'none'
    }
  },
  customized_editor: {
    '& .jodit-react-container, &.jodit-container:not(.jodit_inline)': {
      borderRadius: '4px'
    },
    '& .jodit-container:not(.jodit_inline)': {
      border: '1px solid rgba(0, 0, 0, 0.23)'
    }
  },
}));
